import React from "react";

export default function TrustpilotWidget(): JSX.Element {
    return (
        <div
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="4df6d77700006400050fea24"
            data-style-height="150px"
            data-style-width="100%"
            data-theme="light"
        >
            <a
                href="https://uk.trustpilot.com/review/www.lyst.com"
                target="_blank"
                rel="noreferrer"
            >
                {"Trustpilot"}
            </a>
        </div>
    );
}
